module.exports = __webpack_public_path__ + "img/guide_arrow.da60e095.svg";